import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchSeoData } from "../utils/seoData";

export const useDynamicSeo = () => {
  const location = useLocation();
  const [seo, setSeo] = useState({ title: 'YogaRefer', description: '', keywords: '' });

  useEffect(() => {
    let isMounted = true;

 fetchSeoData().then((data) => {
  if (!isMounted) return;

  let match = data.find((row) => row.route === location.pathname);

  if (!match) {
    const baseSegment = '/' + location.pathname.split('/')[1];
    match = data.find((row) => row.route === baseSegment);
  }

  const title = match?.title || 'YogaRefer';
  const description = match?.description || '';
  const keywords = match?.keywords || '';

  document.title = title;

  let metaTitle = document.querySelector('meta[name="title"]');
  if (!metaTitle) {
    metaTitle = document.createElement('meta');
    metaTitle.name = 'title';
    document.head.appendChild(metaTitle);
  }
  metaTitle.content = title;

  let metaDesc = document.querySelector('meta[name="description"]');
  if (!metaDesc) {
    metaDesc = document.createElement('meta');
    metaDesc.name = 'description';
    document.head.appendChild(metaDesc);
  }
  metaDesc.content = description;

  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    document.head.appendChild(metaKeywords);
  }
  metaKeywords.content = keywords;

  setSeo({ title, description, keywords });
});
    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  return seo;
};
